import script from "./DeleteAccountPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./DeleteAccountPopup.vue?vue&type=script&setup=true&lang=ts"

import "./DeleteAccountPopup.vue?vue&type=style&index=0&id=06708ef9&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06708ef9"]])

export default __exports__